import { type LDClient, type LDContext, type LDContextCommon } from '@launchdarkly/js-client-sdk'

let ldClient: LDClient | null = null
let applicationName: string

type ApplicationName = 'legacy-platform-ui' | 'expert-interface-ui' | 'client-km-interface-ui'

export const getLDClient = () => ldClient
export const setLDClient = (client: LDClient) => {
  ldClient = client
}

export const setApplicationName = (appName: ApplicationName) => {
  applicationName = appName
}
export const getApplicationName = () => applicationName


export function getLDContext(): LDContext {
  if (!applicationName) {
    throw new Error('Application name not set!')
  }

  try {
    const loggedInUser = window.localStorage.getItem('ngStorage-user')
    if (loggedInUser) {
      const parsed = JSON.parse(loggedInUser)
      const { id, fullName } = parsed || {}

      if (id && fullName) {
        const application: LDContextCommon = { key: applicationName }
        const user: LDContextCommon = { key: String(id), name: fullName }
        return { kind: 'multi' as const, application, user }
      }
    }
  } catch (err) {
    // fall through to anonymous context
  }

  const application: LDContextCommon = { key: applicationName }
  return { kind: 'multi' as const, application }
}

export async function refreshLDContext() {
  if (!ldClient) {
    return
  }

  const ldContext = getLDContext()

  await ldClient.identify(ldContext)
}